export const POLICY = `
## Privacy Policy

BIFROSOFT PTE LTD (“BIFROSOFT PTE LTD”, ”us”, ”we”, or ”our”) operates the BTCFi website and decentralized finance (hereinafter referred to as the ”service” or “services”). By visiting the website, or using any of our services, you agree that your personal information will be handled as described on this page.

***

## The information we collect

We collect information about you directly from you and third parties as well as through your use of the service and website.

***

## How we use your information
We may use your information for the following purposes:

- **a. Improve and Develop Services**

  We use your information to identify and ensure that the website and service are working with their intention.

- **b. Promotions**

  We may use your information for marketing and promotional events. We may use your email address to send news and newsletters or any other content with information about products that may interest you. We may use information that we learn from third parties to assist us in our advertisements.

- **c. Laws**

  We may use your information to enforce any applicable Terms of Use, comply with the law, process legal obligations, defend legal claims, and prevent and detect fraud, security, or technical issues.

***

## How we share your information
We may share your information, as follows:

- **a. Third-Party Service Providers**

  We may share your personal data with third-party service providers to provide technical infrastructure services; conduct quality assurance testing; analyze how our service is used; prevent, detect, and respond to unauthorized activities; provide technical and customer support; and or provide other support to us and the service.

- **b. Affiliates**

  We may share some or all of your personal data with any subsidiaries, joint ventures, or other companies under our common control (“affiliates”), in which case we will require our affiliates to honor this Privacy Policy.

- **c. Legal Rights**

  Regardless of any choices you make regarding your personal data (as described below), BTCFi may disclose personal data if it believes in good faith that such disclosure is necessary such as (a) when in connection with any legal investigation; (b) to comply with relevant laws or to respond to subpoenas, warrants, or other legal process served on BTCFi; (c) to protect or defend the rights or property of BTCFi or users of the service; and or (d) to investigate or assist in preventing any violation or potential violation of the law, this Privacy Policy, or our Terms of Service.

- **d. Other Disclosures**

  We may also disclose your personal data to fulfill the purpose for which you provide it; for any other purpose disclosed by us when you provide it; or with your consent.

***

## Use of cookies and information tracking mechanisms
We and our service providers use cookies and other tracking software to track your information regarding the use of the website and service. We may use both cookies and tracking software with other information we collect from you.

***

## Retention and Use of Personal Information
The company will retain personal information for 2 years from the date of marketing consent. After this period, an email will be sent to request the user’s consent again regarding the continuation of marketing information reception. Users can withdraw their consent for marketing information at any time, and in such cases, their personal information will be immediately deleted.

***

## Cookies
Cookies are small files stored on your device (computer or mobile device) for record-keeping and enable a faster visit or log-in process to track your activities.

***

## Disabling Cookies
Most browsers automatically accept cookies, however, if you wish to deny the use of cookies, you can edit your browser settings. Check your browser settings to check how to prevent your device from accepting new cookies and disable cookies.

***

## Third-party tools
We use automated third-party tools to collect data and evaluate the usage of our website and the service. We may also use other tools to track our service to evaluate performance and improve user experience. We do not share your information with these third parties.

***

## Policy Changes
We may update this Privacy Policy from time to time to reflect changes. We will post the revised version here with an updated revision date. If we make a material change to our Privacy Policy, users will be notified in advance.

***

## User Rights and Choices
Users have the following rights:

Request for Information Modification or Deletion: Users can view, modify, or request the deletion of personal information provided, such as email address.

Withdrawal of Marketing Consent: Users can withdraw consent for marketing communications at any time via email.

***

## Contact Us
If you have any questions about this Privacy Policy, please contact us at [help@thebifrost.io](mailto:help@thebifrost.io).
`;
